export const NAMESPACE = 'manager/hr/';
export const STATEPATH = 'manager.hr';
